import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  formatDate,
  getDelhiveryRequestPickupShipmentCount,
  createDelhiveryRequestPickup,
} from "../../../../helper";
import TimePicker from "react-time-picker";
import { Button, Form } from "react-bootstrap";

export default function DelhiveryRequestPickup() {
  const [startDate, setStartDate] = useState(new Date());
  const [numberOfShipments, setNumberOfShipments] = useState(null);
  const currenDate = new Date();
  const [time, setTime] = useState(
    `${currenDate.getHours()}:${currenDate.getMinutes()}`
  );

  useEffect(() => {
    if (!(numberOfShipments >= 0)) {
      getDelhiveryRequestPickupShipmentCount().then((result) =>
        setNumberOfShipments(result)
      );
    }
  });
  return (
    <>
      <div className="d-flex justify-content-center mt-5 align-items-center">
        Request Pickup Date:
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          dateFormat="yyyy-MM-dd"
          minDate={new Date()}
        />
      </div>
      <div className="d-flex justify-content-center mt-5 align-items-center">
        Request Pickup Time:
        <TimePicker
          onChange={(time) => setTime(time)}
          disableClock={true}
          value={time}
        />
      </div>
      <div className="d-flex justify-content-center mt-5 align-items-center">
        Expected number of shipments:
        <Form.Group>
          <Form.Control
            type="number"
            placeholder="Number of shipments"
            value={numberOfShipments}
            onChange={(event) => {
              if (event.target.value >= 0 || event.target.value === "") {
                setNumberOfShipments(
                  event.target.value === "" ? undefined : event.target.value
                );
              } else {
                alert("Invalid number of shipments");
              }
            }}
          />
        </Form.Group>
      </div>
      <div className="d-flex justify-content-center mt-5 align-items-center">
        <Button
          disabled={!(numberOfShipments > 0)}
          onClick={() => {
            if (time && startDate) {
              createDelhiveryRequestPickup({
                pickup_time: `${time}:00`,
                pickup_date: formatDate(startDate),
                pickup_location: "SINDHI 0042569",
                expected_package_count: numberOfShipments,
              }).then(
                (res) =>
                  res &&
                  alert(
                    `Request pickup initiated for ${numberOfShipments} number of shipments`
                  )
              );
            }
          }}
        >
          Submit Request
        </Button>
      </div>
    </>
  );
}
